import _ from 'lodash';
import moment from 'moment';

/***************************
 * userの権限
 ***************************/
export enum RoleEnum {
  Admin = "admin",
  Teacher1 = "teacher1",
  Teacher2 = "teacher2",
  Student = "student"
}

export enum RoleNameEnum {
  Admin = "システム管理者",
  Teacher1 = "管理者",
  Teacher2 = "一般",
  Student = "生徒"
}

export interface ComboboxRole {
  value: string
  text: string
}

// プルダウン・ラジオボタン用 AdminとStudentは使用しない
export function GetComboboxRoleArray() :ComboboxRole[]{
  const rtn: ComboboxRole[] = [];
  rtn.push({value: RoleEnum.Teacher1, text: RoleNameEnum.Teacher1});
  rtn.push({value: RoleEnum.Teacher2, text: RoleNameEnum.Teacher2});
  return rtn;
}

/***************************
 * 学年
 ***************************/
export enum GradeEnum {
  Syo1 = 1,
  Syo2 = 2,
  Syo3 = 3,
  Syo4 = 4,
  Syo5 = 5,
  Syo6 = 6,
}

export enum GradeNameEnum {
  Syo1 = "小1",
  Syo2 = "小2",
  Syo3 = "小3",
  Syo4 = "小4",
  Syo5 = "小5",
  Syo6 = "小6",
}

export interface ComoboxGrade {
  value: number
  text: string
}

export function GetComboboxGradeArray() :ComoboxGrade[] {
  const rtn: ComoboxGrade[] = [];
  rtn.push({value: GradeEnum.Syo1, text: GradeNameEnum.Syo1});
  rtn.push({value: GradeEnum.Syo2, text: GradeNameEnum.Syo2});
  rtn.push({value: GradeEnum.Syo3, text: GradeNameEnum.Syo3});
  rtn.push({value: GradeEnum.Syo4, text: GradeNameEnum.Syo4});
  rtn.push({value: GradeEnum.Syo5, text: GradeNameEnum.Syo5});
  rtn.push({value: GradeEnum.Syo6, text: GradeNameEnum.Syo6});
  return rtn;
}

export function GetGradeNameByGrade(grade: number) :string {
if(grade == GradeEnum.Syo1){
    return GradeNameEnum.Syo1;
  }else if(grade == GradeEnum.Syo2){
    return GradeNameEnum.Syo2;
  }else if(grade == GradeEnum.Syo3){
    return GradeNameEnum.Syo3;
  }else if(grade == GradeEnum.Syo4){
    return GradeNameEnum.Syo4;
  }else if(grade == GradeEnum.Syo5){
    return GradeNameEnum.Syo5;
  }else if(grade == GradeEnum.Syo6){
    return GradeNameEnum.Syo6;
  }else{
    return "";
  }
}

/***************************
 * 実施月 プルダウン用
 ***************************/
export interface ComoboxMonth {
  value: number
  text: string
}

export function GetComboboxMonthArray() :ComoboxMonth[] {
  const rtn: ComoboxMonth[] = [];
  rtn.push({value: 1, text: "1月"});
  rtn.push({value: 2, text: "2月"});
  rtn.push({value: 3, text: "3月"});
  rtn.push({value: 4, text: "4月"});
  rtn.push({value: 5, text: "5月"});
  rtn.push({value: 6, text: "6月"});
  rtn.push({value: 7, text: "7月"});
  rtn.push({value: 8, text: "8月"});
  rtn.push({value: 9, text: "9月"});
  rtn.push({value: 10, text: "10月"});
  rtn.push({value: 11, text: "11月"});
  rtn.push({value: 12, text: "12月"});
  return rtn;
}

/***************************
 * VSH
 ***************************/

export interface ComoboxLevel {
  value: string
  text: string
}

export function GetComboboxLevelArray(): ComoboxLevel[] {
  const rtn: ComoboxLevel[] = [];
  rtn.push({value: "V", text: "V"});
  rtn.push({value: "S", text: "S"});
  rtn.push({value: "H", text: "H"});
  return rtn;
}

/***************************
 * 講座種別
 ***************************/

 export interface ComoboxCourseType {
  value: number
  text: string
}

export function GetComboboxCourseTypeArray(): ComoboxCourseType[] {
  const rtn: ComoboxCourseType[] = [];
  rtn.push({value: 1, text: "マスター"});
  rtn.push({value: 2, text: "社会"});
  rtn.push({value: 3, text: "Web"});
  rtn.push({value: 4, text: "講習"});
  rtn.push({value: 5, text: "土曜マスター"});
  rtn.push({value: 6, text: "最レ"});
  return rtn;
}

/***************************
 * base_sheet_field.kindの権限
 ***************************/
export enum FieldKindEnum {
  Question = 0,
  Allot = 10,
  QrCode = 20,
}

/***************************
 * field_activities.correct_state
 ***************************/
export const CorrectStateEnum = Object.freeze({
  Seitou: 1, 
  Gotou: -1, 
  Tokuten: 0, 
  Pending: -2,
});

/***************************
 * sheet_field.kind Enum
 * api側のConstantsと同じ定義にすること
 ***************************/
 export enum SheetFieldKindEnum {
  FIELD = 0,
  TOTAL_SCORE = 10,
  PART1 = 11,
  VIEW_POINT = 12,
  STUDENT_INFO = 9,
}

/***************************
 * webup_history.webup_type Enum
 ***************************/
 export enum WebupTypeEnum {
  QR_READ = 1,
  FILE_NAME_READ = 2,
}

/***************************
 * API Getのクエリ生成
 ***************************/
export function BuildQuery(object: any, namespace: string) :string {
  return _.map(object, (value: any, key: any) => {
    return namespace ? `${namespace}[${encodeURIComponent(key)}]=${encodeURIComponent(value)}` : `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  }).join('&');
}

/***************************
 * 時刻を指定されたフォーマットに変換
 ***************************/
export function formatDate(value: any, format: string) :string {
  if (value === null || value === "") {
    return "";
  }
  var datetimeAt = new Date(value);
  return moment(datetimeAt).format(format);
}

/***************************
 * 数字配列の合計値を取得
 ***************************/
export function sumArray(array: number[]) {
  let sum = 0;
  for (let i = 0, len = array.length; i < len; i++) {
    sum += array[i];
  }
  return sum;
}

/***************************
 * 試験一覧のページあたりの行数
 ***************************/
export const SheetListRowCount = 20;

/***************************
 * コンバイングループのschool_id
 * 浜学園のschool_id
 ***************************/
export const SchoolIdCombine = 1;
export const SchoolIdHama = 2;

/***************************
 * スクロール
 ***************************/
export function smoothScroll(fromTop: number, toTop: number, fromLeft: number, toLeft: number, elem: HTMLElement) {

  let scrollLeft = fromLeft;
  let scrollTop = fromTop;
  
  const rangeH = (toTop - fromTop) / 20;
  const rangeV = (toLeft - fromLeft) / 20;
  var move = function () { // 実際にスクロールを行う
    
    if((rangeH > 0 && scrollTop + rangeH > toTop) || (rangeH < 0 && scrollTop + rangeH < toTop)){
      scrollTop = toTop;
    }else{
      scrollTop += rangeH;
    }

    if((rangeV > 0 && scrollLeft + rangeV > toLeft) || (rangeV < 0 && scrollLeft + rangeV < toLeft)){
      scrollLeft = toLeft;
    }else{
      scrollLeft += rangeV;
    }

    // スクロールさせる
    elem.scrollTo(scrollLeft, scrollTop);

    // 現在位置が目的位置より進んでいなければアニメーションを続行させる
    if((rangeH > 0 && scrollTop < toTop) || (rangeH < 0 && scrollTop > toTop) || (rangeV > 0 && scrollLeft < toLeft) || (rangeV < 0 && scrollLeft > toLeft)){
      requestAnimationFrame(move);
    }
  };

  requestAnimationFrame(move); // 初回呼び出し
}

/**
 * 整数チェック
 * @param value 
 */
export const isInteger = (value: string): boolean => {

  if (!value) {
    return false;
  }

  const number = Number(value);

  return !isNaN(number) && isFinite(number) && (value.toString().length == parseInt(value).toString().length) && (value.toString().indexOf(".") == -1);
}

/**
 * ファイル名から拡張子取得
 * @param fileName 
 * @returns 
 */
export const getFileExtension = (fileName: string) => {
  var fileNameSplitArray = fileName.split('.');

  if(fileNameSplitArray.length == 1){
    return "";
  }else{
    return fileNameSplitArray[fileNameSplitArray.length - 1].toLowerCase();
  }
}

 /************************************************************
  * テキスト画像サイズ取得時に使用する定数
  ************************************************************/

 export const lineScale = 1.1618;

 /************************************************************
  * テキスト画像のサイズ取得
  ************************************************************/
 
  export const getTextSize = (text: string, fontSize: number, lineHeight: number, defaultText: string = "テキスト") => {
   text = text ? text : defaultText;
   const canvas = document.createElement('canvas') as HTMLCanvasElement;
   const ctx = canvas.getContext('2d');
   ctx.font = `${fontSize}px serif`;
 
   let width = 0;
   let height = 0;
   const lines = text.split("\n");
 
   for(let i = 0; i < lines.length; i++){
     const metrics = ctx.measureText(lines[i]);
     width = metrics.width > width ? metrics.width : width;
     height += Number(fontSize) * lineScale;
     height += i == lines.length - 1 ? 0 : Number(lineHeight);
   }
   height += Number(fontSize) * (lineScale - 1);
 
   return new Size(width, height);
 }

 /************************************************************
 * テキスト画像のBase64生成
 ************************************************************/

export const createBase64Text = (obj: any, defaultText: string = "テキスト") => {
  const text = obj.text ? obj.text : defaultText;
  const canvas = document.createElement('canvas') as HTMLCanvasElement;
  canvas.width = obj.width;
  canvas.height = obj.height;
  const ctx = canvas.getContext('2d');
  ctx.font = `${obj.font_size}px serif`;
  ctx.fillStyle = obj.color;
  let y = 0;
  const lines = text.split("\n");
  for(let i = 0; i < lines.length; i++){
    y += i == 0 ? Number(obj.font_size) : Number(obj.font_size) * lineScale;
    ctx.fillText(lines[i], 0, y);
    y += Number(obj.line_height);
  }
  return canvas.toDataURL("image/png").replace("data:image/png;base64,", "");
}

export class Size {
  width: number
  height: number
  
  constructor(width: number, height: number){
    this.width = width;
    this.height = height;
  }
}

export class Point {
  x: number
  y: number
  
  constructor(x: number, y: number){
    this.x = x;
    this.y = y;
  }
}

export const customAlert = async (bvModal: any, store: any, msg: string) => {
  store.commit("setIsShowingMsgBox", true);
  const result =  await bvModal.msgBoxOk(msg, {autoFocusButton: "ok", id: "msg-box"});
  store.commit("setIsShowingMsgBox", false);
  return result;
}

export const customConfirm = async (bvModal: any, store: any, msg: string, title: string = "確認") => {
  store.commit("setIsShowingMsgBox", true);
  const result =  await bvModal.msgBoxConfirm(msg, {autoFocusButton: "ok", id: "msg-box", title: title});
  store.commit("setIsShowingMsgBox", false);
  return result;
}

export const getCookieValue = (cookies: any, key: string) => {
  
  let rtn: string = null;
  const cookiesArray = cookies.split(';');
  for(let c of cookiesArray){
    const cArray = c.split('=');
    if(cArray[0].trim() == key){
      rtn = cArray[1];
    }
  }
  return rtn;
}

/***************************
 * 本日日付から年度を取得
 ***************************/
export const getNendo = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth();
  if (month === 0) {
    return year - 1;
  }
  return year;
} 
